import React from "react";
import { Switch, Redirect } from "react-router-dom";
import SignIn from "./SignIn/SignIn";
import ForgetPassword from "./ForgetPassword/ForgetPassword";
import Verify from "./Verify/Verify";
import PublicRoute from "hoc/Routes/PublicRoute/PublicRoute";
import IntroLayout from "hoc/IntroLayout";
import VerifyRoute from "hoc/Routes/VerifyRoute/VerifyRoute";
import {useSelector} from "react-redux";
import NewPassword from "./NewPassword/NewPassword";
import SignUp from "./SignUp/SignUp";
import Register from "./Register/Register";

function Auth() {
  const {verifyType} = useSelector( state => ({
    verifyType : state.auth.verifyType
  }));

  return (
      <div>
        <IntroLayout>
          <Switch>
            <Redirect exact from="/auth" to="/auth/sign_in" />
            {/* <Redirect exact from="/auth/signup" to="/auth/sign_in" /> */}
            <PublicRoute
                exact
                path="/auth/sign_in"
                component={SignIn}
            />
            <PublicRoute
                exact
                path="/auth/signup"
                component={SignUp}
            />
            <PublicRoute
                exact
                path="/auth/forgetPassword"
                component={ForgetPassword}
            />
            <VerifyRoute
                exact
                path="/auth/verify"
                restricted
                component={Verify}
                isVerify={verifyType}
            />
            <VerifyRoute
                exact
                path="/auth/register"
                restricted
                component={Register}
                isVerify={verifyType}
            />
            <VerifyRoute
                exact
                path="/auth/newPassword"
                restricted
                component={NewPassword}
                isVerify={verifyType === "resetPassword"}
            />
            <Redirect exact from="*" to="/auth/sign_in" />
          </Switch>
        </IntroLayout>
      </div>
  );
}

export default Auth;
